export default __webpack_public_path__ + "static/img11v-1952913a08541e944741b3fedf7b4d46.jpg";